<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M11.0278 9.72223C11.0278 9.38182 10.7985 9.0841 10.4694 8.99712C10.1428 8.9108 9.79909 9.05355 9.62953 9.34503L9.6232 9.3551C9.61526 9.36743 9.60045 9.38961 9.57876 9.41889C9.53496 9.478 9.46564 9.56261 9.37111 9.65259C9.18066 9.83386 8.90787 10.0188 8.54695 10.0878C8.14011 10.1656 7.87334 10.5584 7.95111 10.9653C8.02889 11.3721 8.42175 11.6389 8.8286 11.5611C9.08699 11.5117 9.31989 11.4329 9.52777 11.3375V14.1667C9.52777 14.5809 9.86356 14.9167 10.2778 14.9167C10.692 14.9167 11.0278 14.5809 11.0278 14.1667V9.72223Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.38889 0.0833282C6.8031 0.0833282 7.13889 0.419115 7.13889 0.833328V2.30556H12.8611V0.833328C12.8611 0.419115 13.1969 0.0833282 13.6111 0.0833282C14.0253 0.0833282 14.3611 0.419115 14.3611 0.833328V2.30556H15.2778C16.9193 2.30556 18.25 3.63627 18.25 5.27778V14.7222C18.25 16.3637 16.9193 17.6944 15.2778 17.6944H4.72222C3.08071 17.6944 1.75 16.3637 1.75 14.7222V5.27778C1.75 3.63627 3.08071 2.30556 4.72222 2.30556H5.63889V0.833328C5.63889 0.419115 5.97467 0.0833282 6.38889 0.0833282ZM16.75 5.27778V6.19444H3.25V5.27778C3.25 4.46469 3.90914 3.80556 4.72222 3.80556H15.2778C16.0909 3.80556 16.75 4.46469 16.75 5.27778ZM16.75 7.69444H3.25V14.7222C3.25 15.5353 3.90914 16.1944 4.72222 16.1944H15.2778C16.0909 16.1944 16.75 15.5353 16.75 14.7222V7.69444Z"
            fill="currentColor"
        />
    </svg>
</template>
